export type ChartProps = {
  data: string[] | number[];
  labels: string[] | number[];
  type: ChartType;
  stepSize?: number;
};

export enum ChartType {
  BAR = "bar",
  LINE = "line",
}
